import { gql } from '@apollo/client';

const CartInfoShared = gql`
  fragment CartInfoShared on Cart {
    id
    state
    hexCode
    subtotal
    discountAmount
    taxAmount
    shippingAmount
    total
    currency
    account {
      id
      accountNumber
    }
    user {
      id
      firstName
      lastName
      email
      phone
    }
    cartItems {
      id
      name
      price
      quantity
      discountAmount
      taxAmount
      shippingAmount
      total
      product {
        id
        name
        featuredImage
        productType
      }
      patient {
        id
        firstName
        lastName
      }
    }
    cartTransactions {
      id
      state
      total
      discountAmount
      taxAmount
      shippingAmount
      authcode
      avs
      code
      transactionId
      message
      status
      amountApproved
      createdAt
    }
    createdAt
    updatedAt
  }
`;

export default CartInfoShared;
